var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{ref:"modal",staticClass:"login-popup",attrs:{"title":"Sign In","hide-footer":""},on:{"cancel":_vm.close,"close":_vm.close}},[_c('login-form',{on:{"success":_vm.success,"navigation":function($event){return _vm.$refs.modal.hide()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }